import {TaxModel} from './Tax.model';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {AggregatedTaxBreakdownFragment, MultiCurrencyPriceFragment} from '../../../../gql/graphql';

export class TaxSummaryModel {
  public taxes: TaxModel[];

  constructor(params: TaxSummaryModel) {
    this.taxes = params.taxes;
  }

  public static fromCheckoutV1({
    taxAmount,
    aggregatedTaxBreakdown,
    modelContext,
  }: {
    taxAmount?: MultiCurrencyPriceFragment | null;
    aggregatedTaxBreakdown?: (AggregatedTaxBreakdownFragment | null)[] | null;
    modelContext: ModelContext;
  }) {
    if (!aggregatedTaxBreakdown || aggregatedTaxBreakdown.length === 0) {
      return new TaxSummaryModel({
        taxes: [TaxModel.fromCheckoutV1({taxAmount, modelContext})],
      });
    }

    return new TaxSummaryModel({
      taxes: aggregatedTaxBreakdown.map((aggregatedTaxBreakdown) =>
        TaxModel.fromCheckoutV1({
          taxAmount: aggregatedTaxBreakdown?.aggregatedTaxAmount,
          modelContext,
          taxName: aggregatedTaxBreakdown?.taxName,
        })
      ),
    });
  }
}
